import type { Printer } from '@features/printer/types';

import Routing from '@core/api/routing';
import { baseApi } from '@core/api/base-api';

export const printerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    printerList: builder.query<Printer[], void>({
      query: () => ({
        url: Routing.generate('rest_printer_list', {}, true),
        method: 'GET',
      }),
    }),
  }),
});

export const { usePrinterListQuery } = printerApi;
